import styled from "styled-components";
import { Column, Row } from "components/styles";
import { Title, TextData } from "views/components/Schedules/components/UpdateActivityPopup/styles";

export const Content = styled(Column).attrs({
    width: "100%",
    gap: "24px",
    padding: "40px 16px 0"
})`
    box-sizing: border-box;
`;

export const ModalTitle = styled(Title)`
    align-self: center;
    width: 100%;
    margin: 0;
    font-family: Lato;
    font-size: 20px;
    font-weight: 900;
    line-height: 32px;
    text-align: center;
`;

export const Metadata = styled(Row).attrs({
    gap: "12px",
    justifyContent: "flex-start",
    wrap: "nowrap",
    width: "100%"
})``;

export const MetadataText = styled(TextData)`
    width: auto;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
`;

export const Toggle = styled.div`
    & .switch label {
        font-family: Lato;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-align: right;
    }
`;
